<template>
  <div class="tooltipCont tooltip-space" :aria-labelledby="'tooltip-' + sid" role="tooltip" tabindex="0" @focus="inFocus" @blur="outFocus">
    <span class="sr-only">{{ ariaLabel }}</span>

    <v-popover :placement="placement || 'top'" :trigger="trigger || 'hover'" class="w-tooltip" :open="isFocus" :id="'tooltip-' + sid">
      <span class="footnote font-md text-primary">
        <i class="fa fa-fw fa-question-circle" aria-hidden="true"></i>
      </span>

      <template v-slot:popover>
        <slot>{{ ariaLabel }}</slot>
      </template>
    </v-popover>
  </div>
</template>
<script>
import {VPopover} from 'v-tooltip';

export default {
  name: 'w-tooltip',
  components: {
    VPopover
  },
  props: {
    tooltip: {type: String, default: null},
    placement: {type: String, default: 'top'},
    trigger: {type: String, default: 'hover'}
  },
  data() {
    return {ariaLabel: '', isFocus: false, sid: Math.round(Math.random() * 1000000)};
  },
  methods: {
    setAriaLabel() {
      if (this.tooltip) return (this.ariaLabel = this.tooltip);

      if (!this.$slots.default || !this.$slots.default.length) {
        return (this.ariaLabel = '');
      }

      if (!this.$slots.default[0].elm) {
        return (this.ariaLabel = '');
      }
      this.ariaLabel = this.$slots.default[0].elm.outerText || this.$slots.default[0].elm.wholeText;
    },
    inFocus() {
      this.isFocus = true;
    },
    outFocus() {
      this.isFocus = false;
    }
  },
  mounted() {
    this.setAriaLabel();
  },
  watch: {
    tooltip() {
      this.setAriaLabel();
    }
  }
};
</script>

<style scoped>
/* .w-tooltip{
    margin-left: 5px;
} */
.footnote {
  padding-left: 0;
}
.footnote > i {
  width: auto;
}
</style>
<style>
.tooltip-space {
  margin-left: 5px !important;
}
.v-popover {
  display: inline-block !important;
}
.tooltip {
  display: block !important;
  z-index: 10000;
  background: none !important;
  border: none;
  box-shadow: none;
}
.popover {
  max-width: 400px !important;
}
.tooltip .tooltip-inner {
  background: white;
  max-width: 400px !important;
  border: 1px solid #ccc;
  border-radius: 0 !important;
  color: black;
  border-radius: 16px;
  padding: 15px;
  font-size: 15px;
  font-weight: normal !important;
  -webkit-box-shadow: 0px 0px 40px 1px rgba(0, 0, 0, 0.26);
  -moz-box-shadow: 0px 0px 40px 1px rgba(0, 0, 0, 0.26);
  box-shadow: 0px 0px 40px 1px rgba(0, 0, 0, 0.26);
  font-family: 'Open Sans', Arial, Helvetica, Sans-Serif;
  text-align: left;
}
.tooltip .tooltip-arrow {
  width: 0;
  height: 0;
  border-style: solid;
  position: absolute;
  margin: 5px;
  border-color: #bbb;
  z-index: 1;
}
.tooltip[x-placement^='top'] {
  margin-bottom: 5px;
}
.tooltip[x-placement^='top'] .tooltip-arrow {
  border-width: 5px 5px 0 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  bottom: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}
.tooltip[x-placement^='bottom'] {
  margin-top: 5px;
}
.tooltip[x-placement^='bottom'] .tooltip-arrow {
  border-width: 0 5px 5px 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-top-color: transparent !important;
  top: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}
.tooltip[x-placement^='right'] {
  margin-left: 5px;
}
.tooltip[x-placement^='right'] .tooltip-arrow {
  border-width: 5px 5px 5px 0;
  border-left-color: transparent !important;
  border-top-color: transparent !important;
  border-bottom-color: transparent !important;
  left: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}
.tooltip[x-placement^='left'] {
  margin-right: 5px;
}
.tooltip[x-placement^='left'] .tooltip-arrow {
  border-width: 5px 0 5px 5px;
  border-top-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  right: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}
.tooltip[aria-hidden='true'] {
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.15s, visibility 0.15s;
}
.tooltip[aria-hidden='false'] {
  visibility: visible;
  opacity: 1;
  transition: opacity 0.15s;
}
.tooltipCont {
  display: inline-block !important;
}
</style>
